export const topicsData = [
  { tag: '热门福利推荐', heat: '128.6万热度', hot: true, desc: '本周最受欢迎的视频合集' },
  { tag: '91麻豆精选', heat: '96.3万热度', hot: true, desc: '麻豆系列经典内容汇聚' },
  { tag: '高清1080P专区', heat: '87.5万热度', hot: true, desc: '超清画质观影体验' },
  { tag: '今日最新上线', heat: '52.8万浏览', hot: true, desc: '每日新鲜资源直达' },
  { tag: '免费福利合集', heat: '74.2万关注', hot: true, desc: '零成本畅享精选内容' },
  { tag: '精彩短视频', heat: '63.9万点击', hot: false, desc: '快餐式观影新体验' },
  { tag: '长片珍藏系列', heat: '45.3万收藏', hot: false, desc: '完整作品一次看过瘾' },
  { tag: '新锐创作者', heat: '38.7万关注', hot: false, desc: '发现潜力原创内容' },
  { tag: '经典重温', heat: '29.1万浏览', hot: false, desc: '高分经典视频回顾' },
];

export const carouselData = [
  {
    title: '本周热门福利专题',
    desc: '编辑团队精选本周播放量最高的免费视频内容，涵盖多元题材与热门话题，一次收藏全部看完。91免费视频网站每周更新精选专题，让你不错过任何精彩瞬间。',
    image: 'https://readdy.ai/api/search-image?query=Warm%20gradient%20abstract%20composition%20with%20coral%20and%20amber%20soft%20light%20elements%20flowing%20shapes%20representing%20curated%20entertainment%20collection%20modern%20editorial%20digital%20art%20with%20elegant%20cinematic%20atmosphere&width=800&height=520&seq=carousel-01&orientation=landscape',
    tag: '本周精选',
    meta: '128.6万热度',
  },
  {
    title: '91麻豆系列完整合集',
    desc: '91麻豆免费视频网站经典系列一次集齐，覆盖热门剧情与高分推荐。高清画质流畅播放，无论新老用户都能快速找到心仪内容，是麻豆爱好者的首选收藏目录。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20entertainment%20collection%20showcase%20with%20elegant%20golden%20spotlight%20effect%20warm%20ambient%20tones%20modern%20sophisticated%20aesthetic%20abstract%20visual%20composition%20editorial%20style&width=800&height=520&seq=carousel-02&orientation=landscape',
    tag: '麻豆合集',
    meta: '96.3万热度',
  },
  {
    title: '高清超清观影体验专区',
    desc: '支持1080P超清画质在线播放，色彩精准还原，画面流畅不掉帧。91免费视频网站持续升级播放技术，为你带来影院级的观看享受，高清资源占比超过95%。',
    image: 'https://readdy.ai/api/search-image?query=High%20end%20home%20theater%20scene%20with%20large%20screen%20displaying%20vivid%20colorful%20abstract%20content%20warm%20ambient%20lighting%20modern%20minimalist%20interior%20design%20elegant%20cinematic%20atmosphere&width=800&height=520&seq=carousel-03&orientation=landscape',
    tag: '超清体验',
    meta: '87.5万热度',
  },
  {
    title: '每日上新不间断更新',
    desc: '编辑团队每天精选数百部最新免费在线视频资源，分类清晰标签完善。从热门推荐到冷门佳片，每日更新板块让你第一时间发现精彩内容，更新节奏稳定可靠。',
    image: 'https://readdy.ai/api/search-image?query=Calendar%20with%20glowing%20content%20markers%20and%20streaming%20interface%20elements%20warm%20coral%20and%20amber%20gradients%20modern%20minimalist%20digital%20art%20composition%20abstract%20fresh%20daily%20concept&width=800&height=520&seq=carousel-04&orientation=landscape',
    tag: '每日上新',
    meta: '52.8万浏览',
  },
  {
    title: '免费资源大全一站畅享',
    desc: '91免费视频网站全站内容零成本观看，无需注册无需付费。包括91免费在线视频、91福利视频在线等所有板块永久免费开放，真正实现高清视频自由观看的承诺。',
    image: 'https://readdy.ai/api/search-image?query=Open%20treasure%20chest%20concept%20with%20glowing%20golden%20light%20and%20floating%20digital%20media%20icons%20warm%20amber%20tones%20abstract%20artistic%20composition%20symbolizing%20abundance%20and%20free%20access%20modern%20digital%20art&width=800&height=520&seq=carousel-05&orientation=landscape',
    tag: '永久免费',
    meta: '74.2万关注',
  },
  {
    title: '编辑精选推荐榜单',
    desc: '91精彩视频在线观看编辑精选，根据播放量、用户评分与内容质量综合排序。包含91麻豆免费视频网站热门推荐和91福利视频在线高分作品，帮你快速找到优质内容。',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20stage%20spotlight%20with%20golden%20warm%20highlights%20and%20curated%20showcase%20atmosphere%20abstract%20cinematic%20scene%20with%20premium%20editorial%20quality%20sophisticated%20modern%20aesthetic&width=800&height=520&seq=carousel-06&orientation=landscape',
    tag: '编辑精选',
    meta: '63.9万点击',
  },
];

export const appData = {
  title: '随时随地，高清视频随心看',
  desc: '91免费视频网站移动端全面适配，无论是手机浏览器直接访问还是下载专属应用，都能获得流畅的高清播放体验。91免费在线视频、91麻豆免费视频网站、91福利视频在线等全部内容移动端同步更新，通勤路上、休息间隙、睡前放松，打开即看无需等待。',
  image: 'https://readdy.ai/api/search-image?query=Smartphone%20mockup%20displaying%20video%20streaming%20app%20interface%20with%20warm%20coral%20and%20amber%20UI%20elements%20on%20light%20neutral%20clean%20background%20modern%20minimalist%20product%20photography%20editorial%20style&width=500&height=700&seq=app-mockup-01&orientation=portrait',
  features: ['支持离线缓存下载', '1080P超清画质播放', '每日个性化内容推送', '纯净观影零广告'],
  badge: '超过百万用户的选择',
};

export const updatesData = [
  { time: '8分钟前', title: '今日新增热门福利视频资源320+部已上线', tag: '上新速报', type: 'new', highlight: true },
  { time: '45分钟前', title: '91麻豆免费视频网站专区新增经典系列合集', tag: '内容更新', type: 'update', highlight: false },
  { time: '2小时前', title: '高清播放线路全面扩容，晚间高峰更流畅', tag: '系统优化', type: 'update', highlight: false },
  { time: '5小时前', title: '本周热门话题榜单已刷新，新晋榜首诞生', tag: '榜单更新', type: 'rank', highlight: false },
  { time: '8小时前', title: '新增精彩短视频板块，快餐式观影新体验', tag: '功能上线', type: 'feature', highlight: false },
  { time: '1天前', title: '移动端播放体验全面升级，加载速度提升40%', tag: '技术升级', type: 'update', highlight: false },
  { time: '2天前', title: '免费福利视频在线资源库突破万部大关', tag: '里程碑', type: 'new', highlight: false },
  { time: '3天前', title: '全站搜索与标签系统优化完成，找片更精准', tag: '功能优化', type: 'update', highlight: false },
  { time: '5天前', title: '91免费视频网站通过安全检测认证', tag: '安全公告', type: 'feature', highlight: false },
];

export const rankingData = [
  { rank: 1, title: '本周最热福利视频合集', heat: '128.6万', trend: 'up', tag: '热门' },
  { rank: 2, title: '91麻豆精选专题推荐', heat: '96.3万', trend: 'up', tag: '精选' },
  { rank: 3, title: '高清在线观看人气专区', heat: '87.5万', trend: 'same', tag: '高清' },
  { rank: 4, title: '免费视频资源大全导航', heat: '74.2万', trend: 'up', tag: '导航' },
  { rank: 5, title: '每日更新热门排行榜', heat: '63.9万', trend: 'down', tag: '日榜' },
  { rank: 6, title: '精彩短视频速看专区', heat: '52.8万', trend: 'up', tag: '短视频' },
  { rank: 7, title: '91福利视频在线精选', heat: '45.3万', trend: 'same', tag: '福利' },
];

export const featuresData = [
  {
    icon: 'ri-vip-diamond-line',
    title: '全站永久免费',
    desc: '91免费视频网站所有内容零成本观看，无需注册会员、无需付费订阅、无需充值。91免费在线视频、91麻豆免费视频网站、91福利视频在线全部免费开放。',
  },
  {
    icon: 'ri-hd-line',
    title: '超清画质播放',
    desc: '支持1080P超清在线播放，自适应码率确保流畅观影。色彩还原精准，画面细腻清晰，95%以上资源支持高清画质。',
  },
  {
    icon: 'ri-refresh-line',
    title: '每日稳定更新',
    desc: '编辑团队每日精选数百部最新资源，涵盖热门推荐、经典合集、新锐原创等多元内容。91免费在线视频资源库持续增长不停歇。',
  },
  {
    icon: 'ri-shield-check-line',
    title: '安全绿色浏览',
    desc: '全站内容经过多重安全检测，不含恶意代码与弹窗广告。91麻豆免费视频网站提供纯净观影环境，用户隐私严格保护。',
  },
  {
    icon: 'ri-smartphone-line',
    title: '全端无缝切换',
    desc: 'PC端、手机浏览器、平板设备全面适配，91福利视频在线在任何设备上都能流畅播放。数据同步，接续观看不间断。',
  },
];

export const mediaData = [
  {
    title: '热门福利视频精选集锦',
    duration: '05:32',
    views: '128.6万次播放',
    image: 'https://readdy.ai/api/search-image?query=Stylish%20video%20content%20thumbnail%20with%20warm%20coral%20and%20amber%20tone%20gradient%20overlay%20modern%20streaming%20platform%20aesthetic%20soft%20cinematic%20lighting%20abstract%20composition%20editorial%20visual%20art&width=800&height=500&seq=media-thumb-01&orientation=landscape',
    tag: '热门',
    desc: '本周最受欢迎的视频内容精选',
  },
  {
    title: '91麻豆免费视频推荐专区',
    duration: '08:15',
    views: '96.3万次播放',
    image: 'https://readdy.ai/api/search-image?query=Elegant%20entertainment%20scene%20with%20warm%20ambient%20lighting%20and%20comfortable%20cinematic%20interior%20setting%20editorial%20style%20photography%20for%20premium%20video%20content%20presentation%20abstract%20composition&width=800&height=500&seq=media-thumb-02&orientation=landscape',
    tag: '精选',
    desc: '麻豆系列独家内容推荐合集',
  },
  {
    title: '免费高清视频在线体验',
    duration: '12:08',
    views: '87.5万次播放',
    image: 'https://readdy.ai/api/search-image?query=Modern%20home%20cinema%20setup%20with%20large%20screen%20displaying%20vibrant%20colorful%20content%20warm%20cozy%20ambient%20lighting%20comfortable%20immersive%20viewing%20experience%20editorial%20photography%20abstract%20style&width=800&height=500&seq=media-thumb-03&orientation=landscape',
    tag: '高清',
    desc: '超清画质在线观影实拍体验',
  },
];

export const cardsData = [
  {
    title: '91免费在线视频专区',
    desc: '汇集全网最新最全的91免费在线视频资源，按题材、热度、更新时间等多维度分类导航。无论是热门推荐、新锐作品还是经典回顾，一个专区满足你的全部观看需求。',
    image: 'https://readdy.ai/api/search-image?query=Modern%20organized%20digital%20video%20library%20concept%20with%20warm%20coral%20and%20amber%20lighting%20minimalist%20editorial%20style%20clean%20aesthetic%20shelves%20and%20screens%20composition%20abstract%20visual&width=600&height=420&seq=cards-01&orientation=landscape',
    tag: '热门专区',
    featured: true,
  },
  {
    title: '91麻豆经典系列合集',
    desc: '收录91麻豆免费视频网站全系列经典作品，按剧情线、演员与发布时间完整整理，方便连续观看与收藏。',
    image: 'https://readdy.ai/api/search-image?query=Premium%20content%20archive%20concept%20with%20elegant%20display%20warm%20golden%20ambient%20light%20sophisticated%20organization%20system%20abstract%20visual%20composition%20editorial%20style&width=400&height=300&seq=cards-02&orientation=landscape',
    tag: '麻豆合集',
    featured: false,
  },
  {
    title: '每日福利视频在线更新',
    desc: '每天准时更新91福利视频在线最新资源，包括热门推荐、冷门佳片、短视频等多元类型，不错过任何一部好片。',
    image: 'https://readdy.ai/api/search-image?query=Daily%20fresh%20media%20content%20concept%20calendar%20with%20glowing%20streaming%20elements%20warm%20amber%20and%20coral%20tones%20modern%20abstract%20digital%20art%20composition%20clean%20aesthetic&width=400&height=300&seq=cards-03&orientation=landscape',
    tag: '每日更新',
    featured: false,
  },
  {
    title: '高清观影设置与优化指南',
    desc: '详细介绍如何在91免费视频网站上获得最佳高清观影体验，包括画质选择、线路切换、网络优化与设备适配等实用技巧，让你的观影体验升级到新高度。',
    image: 'https://readdy.ai/api/search-image?query=High%20definition%20media%20optimization%20concept%20with%20elegant%20tech%20elements%20warm%20ambient%20lighting%20modern%20digital%20visual%20abstract%20composition%20clean%20aesthetic&width=600&height=420&seq=cards-04&orientation=landscape',
    tag: '观影指南',
    featured: true,
  },
  {
    title: '91精彩视频编辑推荐榜',
    desc: '以编辑视角精选的每周高分视频推荐列表，结合播放数据与内容质量给出客观评价。',
    image: 'https://readdy.ai/api/search-image?query=Curated%20editorial%20selection%20concept%20with%20golden%20spotlight%20and%20warm%20elegant%20atmosphere%20abstract%20cinematic%20visual%20composition%20modern%20sophisticated%20aesthetic&width=400&height=300&seq=cards-05&orientation=landscape',
    tag: '编辑推荐',
    featured: false,
  },
  {
    title: '免费视频资源分类导航',
    desc: '全面梳理免费视频在线观看入口，按题材类型与观看偏好智能分类，帮你高效定位。',
    image: 'https://readdy.ai/api/search-image?query=Digital%20navigation%20map%20concept%20with%20interconnected%20pathways%20and%20warm%20coral%20amber%20glow%20modern%20minimalist%20abstract%20art%20clean%20flowing%20design%20visual%20composition&width=400&height=300&seq=cards-06&orientation=landscape',
    tag: '分类导航',
    featured: false,
  },
  {
    title: '原创内容创作者扶持计划',
    desc: '91免费视频网站推出创作者激励计划，为优秀原创内容提供流量支持与展示位，共同打造更丰富的免费在线视频生态。',
    image: 'https://readdy.ai/api/search-image?query=Creative%20community%20support%20concept%20with%20warm%20inspiring%20atmosphere%20collaborative%20energy%20abstract%20visual%20composition%20modern%20editorial%20art%20style%20coral%20and%20amber%20tones&width=400&height=300&seq=cards-07&orientation=landscape',
    tag: '创作者',
    featured: false,
  },
];

export const aboutData = {
  title: '关于91免费视频网站',
  desc: '91免费视频网站诞生于对免费优质视频资源的执著追求。我们深知用户对高清、免费、稳定在线视频的需求，因此倾力打造了这个覆盖91免费在线视频、91麻豆免费视频网站、91福利视频在线等海量资源的聚合平台。\n\n从上线之初的数百部视频，到如今超过十万部的资源库，我们始终坚持：全站免费、每日更新、高清播放、安全浏览。无论是热门的福利合集还是冷门的精品佳作，在这里都能零成本畅享。\n\n我们的编辑团队每日筛选优质内容，技术团队持续优化播放体验，只为给你最流畅、最安心的在线观影之旅。91免费视频网站，不止是视频平台，更是你值得信赖的娱乐伙伴。',
  image: 'https://readdy.ai/api/search-image?query=Modern%20creative%20workspace%20with%20team%20collaborating%20around%20screens%20and%20content%20warm%20natural%20light%20editorial%20photography%20style%20minimalist%20office%20setting%20abstract%20composition&width=650&height=520&seq=about-01&orientation=landscape',
  stats: [
    { label: '在线视频总量', value: '10万+', icon: 'ri-video-line' },
    { label: '每日新增更新', value: '500+', icon: 'ri-upload-cloud-2-line' },
    { label: '覆盖用户群体', value: '百万级', icon: 'ri-user-heart-line' },
    { label: '高清资源占比', value: '95%', icon: 'ri-hd-line' },
  ],
};

export const faqData = [
  {
    q: '91免费视频网站真的完全免费吗？需要注册吗？',
    a: '完全免费，无需注册！91免费视频网站所有在线视频资源均为免费观看，不需要注册会员、不需要付费订阅、不需要任何充值。您可以直接打开访问91免费在线视频、91麻豆免费视频网站、91福利视频在线等全部内容。我们通过广告合作维持运营，不会向用户收费。',
  },
  {
    q: '视频播放卡顿或者加载慢怎么办？',
    a: '我们提供多条播放线路智能切换功能。如果遇到卡顿：建议优先在Wi-Fi环境下观看高清视频；可尝试切换播放线路（点击播放器设置中的线路选择）；确保浏览器为最新版本，推荐Chrome或Edge浏览器；关闭其他占用带宽的应用。91免费视频网站持续扩容服务器，确保流畅体验。',
  },
  {
    q: '手机和平板可以观看吗？体验怎么样？',
    a: '完全支持。91免费视频网站针对移动端做了深度适配，无论是手机浏览器还是平板设备，都能获得流畅的1080P高清播放体验。移动端同步更新91福利视频在线、91精彩视频在线观看等全部内容。支持横屏/竖屏自由切换，触控操作顺手便捷。',
  },
  {
    q: '网站内容多久更新一次？更新量有多少？',
    a: '我们坚持每日更新，每天新增300-500部免费在线视频资源。包括91免费在线视频最新内容、91麻豆免费视频网站推荐更新、91福利视频在线每日上新等板块。关注"最新动态"区域可获取实时更新资讯，热门话题榜单也会每日刷新排名。',
  },
  {
    q: '如何在众多内容中找到我想看的视频？',
    a: '有多种方式帮助您快速定位：使用首页"内容索引"板块按分类浏览；参考"热门排行"了解当前最受欢迎的内容；浏览"推荐内容"卡片发现编辑精选；关注"热门话题"标签了解最新趋势。91精彩视频在线观看的推荐系统也在持续优化中。',
  },
];

export const indexData = [
  { title: '91免费在线视频', count: '3,200+部', icon: 'ri-movie-2-line', desc: '全网最新免费视频合集' },
  { title: '91麻豆免费视频', count: '1,800+部', icon: 'ri-clapperboard-line', desc: '麻豆系列经典全集' },
  { title: '91福利视频在线', count: '2,500+部', icon: 'ri-heart-3-line', desc: '福利内容每日上新' },
  { title: '免费高清专区', count: '4,100+部', icon: 'ri-hd-line', desc: '1080P超清观影体验' },
  { title: '精彩推荐榜单', count: '1,200+部', icon: 'ri-star-line', desc: '编辑精选高分内容' },
  { title: '热门合集收藏', count: '980+部', icon: 'ri-stack-line', desc: '按主题整理的视频合集' },
  { title: '今日最新上线', count: '500+部/日', icon: 'ri-calendar-check-line', desc: '每天新鲜资源直达' },
];

export const commentsData = [
  {
    name: '资深影迷小王',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20male%20portrait%20with%20casual%20confident%20expression%20soft%20natural%20lighting%20minimalist%20clean%20background%20editorial%20headshot%20warm%20tone&width=80&height=80&seq=avatar-01&orientation=squarish',
    content: '用了91免费视频网站快一年了，真的是良心平台。资源更新速度快，画质清晰不卡顿，最关键的是完全免费。91麻豆免费视频网站的专区内容质量特别高，每次打开都有惊喜。推荐给身边很多朋友了，大家都是好评！',
    rating: 5,
    time: '3天前',
  },
  {
    name: '追剧少女李姐',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20female%20portrait%20with%20friendly%20warm%20smile%20soft%20natural%20lighting%20minimalist%20clean%20background%20editorial%20headshot%20warm%20tone&width=80&height=80&seq=avatar-02&orientation=squarish',
    content: '作为一个天天刷视频的人，91免费视频网站已经成为我每天必打开的网站。福利视频在线的更新频率很高，而且分类很清晰，找自己想看的特别快。手机上看也很方便，上班路上也能追，真的离不开。',
    rating: 5,
    time: '5天前',
  },
  {
    name: '内容创作者张老师',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20male%20professional%20portrait%20with%20creative%20expression%20soft%20natural%20lighting%20minimalist%20clean%20background%20editorial%20headshot%20warm%20tone&width=80&height=80&seq=avatar-03&orientation=squarish',
    content: '作为内容创作者，我需要经常参考各种视频作品。91免费视频网站的资源覆盖非常全面，91免费在线视频的分类和推荐算法做得不错，总能发现优质内容。希望平台越做越好，也期待更多原创作者加入。',
    rating: 4,
    time: '1周前',
  },
  {
    name: '大学生小陈同学',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20college%20student%20portrait%20with%20cheerful%20bright%20expression%20soft%20natural%20lighting%20minimalist%20clean%20background%20editorial%20headshot%20warm%20tone&width=80&height=80&seq=avatar-04&orientation=squarish',
    content: '宿舍网速一般但91免费视频网站播放还是很流畅！免费福利视频在线的清晰度让我很惊喜，完全不输那些付费平台。已经安利给整个寝室了，大家都说好用。特别感谢平台提供的免费高清观影体验。',
    rating: 5,
    time: '1周前',
  },
  {
    name: '自由职业者老刘',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20asian%20man%20creative%20relaxed%20portrait%20with%20genuine%20expression%20soft%20natural%20lighting%20minimalist%20clean%20background%20editorial%20headshot%20warm%20tone&width=80&height=80&seq=avatar-05&orientation=squarish',
    content: '用过的免费在线视频网站里，91免费视频网站是最稳定的。91麻豆免费视频网站的内容质量很高，编辑精选的眼光很专业。我经常根据排行榜来找片，基本不会踩雷。希望平台继续保持更新频率，会一直支持的！',
    rating: 4,
    time: '2周前',
  },
];